import { useApiUserApplicationsCommentsList } from "@/api/lctApIComponents";
import { useAppSelector } from "./reduxHooks";
import { useUserAppInfo } from "./useUserAppInfo";
import { CommentType } from "@/utils/constants";

export const useFeedback = (userAppId: string) => {
  const token = useAppSelector((state) => state.user.authKey);
  const { data, refetch } = useApiUserApplicationsCommentsList(
    { headers: { Authorization: `Token ${token}` }, pathParams: { userapp: userAppId } },
    { enabled: !!userAppId },
  );
  const { carbonScore } = useUserAppInfo(userAppId);

  const isStaff = useAppSelector((state) => state.user.isStaff);

  const feedbackLocked = !isStaff;

  const carbonScoreComments = data?.results?.filter((comment) => comment.comment_type === CommentType.CARBON_SCORE);
  const mostRecentCarbonScoreComment = carbonScoreComments?.sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  )[0];
  const feedbackItems =
    data?.results
      ?.filter((comment) => comment.comment_type === CommentType.FEEDBACK)
      .sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()) || [];
  const feedbackItemsLength = feedbackItems?.length + (mostRecentCarbonScoreComment ? 1 : 0);

  return {
    feedbackItems,
    feedbackItemsLength,
    feedbackLocked,
    carbonScoreComment: mostRecentCarbonScoreComment,
    refetchFeedbackItems: refetch,
    carbonScore,
  };
};
